<div class="CeFormField" [class]="inputModifiers()">
    <div class="CeFormField-label">
        <ng-content select="[ce-input-label]"></ng-content>
        @if(isRequired()){
        <span class="CeFormField-required u-spacing-xs-ml">*</span>
        }
        <ng-content select="[ce-input-error]"></ng-content>
    </div>
    <div class="CeFormField-input" [class]="formFieldClassComputed()" (click)="inputSelected()" onKeyPress="">
        <ng-content select="[ce-input-prefix]"></ng-content>
        <ng-content></ng-content>
        <ng-content select="[ce-input-suffix]"></ng-content>
    </div>
    <ng-content select="[ce-input-hint-persistent]"></ng-content>
    @if (!hideErrorSpace) {
    <div class="CeFormField-inputHintWrapper">
        <div class="CeFormField-inputHintContainer">
            <ng-content select="[ce-input-hint]"></ng-content>
        </div>
    </div>
    }
</div>
